import { Separator } from '@/components/ui/separator'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

import LogoIcon from 'public/images/logo-icon.svg?react'
import PremiumModal from 'app/frontend/base/components/PremiumModal'
import GameSwitcher from './GameSwitcher'

const Footer = () => {
  const { t } = useTranslation()

  return (
    <footer className='border-t bg-card'>
      <div className='root-width max-md:px-4 mt-4 mb-4 flex md:items-center justify-between'>
        <div className='md:flex md:items-center'>
          <Link to='/' className='mr-6 h-10 block'>
            <LogoIcon className='w-10 h-10' color='var(--color-primary)' />
          </Link>

          <div className='max-md:mt-2 hidden max-lg:block'>
            <GameSwitcher />
          </div>
        </div>
        <div className='flex flex-col md:flex-row md:items-center md:gap-3 max-md:text-right max-md:mr-2 text-sm'>
          <a href='https://discord.gg/86eUAFz' target='_blank' rel='noreferrer'>
            {t('footer.support')}
          </a>
          <Separator orientation='vertical' className='h-2.5' />

          <PremiumModal>
            <a className='cursor-pointer'>{t('shared.subscribe')}</a>
          </PremiumModal>

          <Separator orientation='vertical' className='h-2.5' />
          <Link to='/api'>{t('footer.api')}</Link>
          <Separator orientation='vertical' className='h-2.5' />
          <Link to='/privacy-policy'>{t('footer.privacy-policy')}</Link>
          <Separator orientation='vertical' className='h-2.5' />
          <Link to='/terms-of-use'>{t('footer.terms-of-use')}</Link>
        </div>
      </div>
    </footer>
  )
}

export default Footer
